import licensePlateGame from '../img/webShots/License-Plate-Game-2019-01-06-10_58_59.png'

export const web = [
    { 
        key: "notes-app",
        name: "Sticky",
        link: "http://sticky-app.netlify.com",
        github: null,
        picture: null,
    },
    { 
        key: "devProfiles",
        name: "Developer Profiles",
        link: "https://ecstatic-dev-profiles.netlify.com/",
        github: "https://github.com/Lambda-School-Labs/labs9-developer-profiles",
        picture: null,
    },
    { 
        key: "sog",
        name: "Sea of Green",
        link: "https://sea-of-green.herokuapp.com/",
        github: "https://github.com/MKerbleski/chart-js-demo",        
        picture: null,
    },
    { 
        key: "charts",
        name: "ChartJS Demo",
        link: "https://chart-js-demo.herokuapp.com/",
        github: "https://github.com/MKerbleski/sea-of-green",        
        picture: null,
    },
    { 
        key: "LPG",
        name: "License Plate Game",
        link: "https://mkerbleski.github.io/License-Plate-Game/",
        github: "https://github.com/MKerbleski/License-Plate-Game",        
        picture: null,
    },
    { 
        key: "mud",
        name: "MUD",
        link: "https://amudappthatdoesntsuck.xyz/",
        github: "https://github.com/MKerbleski/LambdaMUD-Client",
        picture: null,
    },
    { 
        key: "gameOfLife",
        name: "Cellular Automata",
        link: "https://game-of-life-mjk.netlify.com/",
        github: "https://github.com/MKerbleski/Conways-Life",
        picture: null,
    },
    { 
        key: "frontEnd",
        name: "S&J Architecture",
        link: "https://mkerbleski.github.io/User-Interface-Project-Week/",
        github: "https://github.com/MKerbleski/User-Interface-Project-Week",
        picture: null,
    },
    { 
        key: "frontEnd",
        name: "Portfolio",
        link: "https://mikerble.ski",
        github: "https://github.com/MKerbleski/Portfolio",
        picture: null,
    },
    // { 
    //     key: "hackaathon",
    //     name: "Job Trends",
    //     link: "https://jobtrends.site/",
    //     github: "https://github.com/MKerbleski/Hackathon-July2018",
    //     picture: null,
    // },
    { 
        key: "silverScreens",
        name: "Silver Screens",
        link: "https://silverscreens.xyz",
        github: "https://github.com/MKerbleski/SilverScreens",
        picture: null,
    },
]


// WEBPACK FOOTER //
// ./src/data/webObj.js